// Rotulos exibidos para as etapas. Os IDs internos (entrada, m1..m4, agendado, perdido) nao mudam.
export const ETAPAS = [
  { id: "entrada", label: "Entrada", short: "Entrada" },
  { id: "m1", label: "1ª mensagem", short: "1ª msg" },
  { id: "m2", label: "2ª mensagem", short: "2ª msg" },
  { id: "m3", label: "3ª mensagem", short: "3ª msg" },
  { id: "m4", label: "4ª mensagem", short: "4ª msg" },
  { id: "agendado", label: "Agendado", short: "Agendado" },
  { id: "perdido", label: "Não convertido", short: "Não conv." },
];

export const ETAPA_LABEL = Object.fromEntries(ETAPAS.map((e) => [e.id, e.label]));
export const ETAPA_SHORT = Object.fromEntries(ETAPAS.map((e) => [e.id, e.short]));

// Etapas usadas em formulários (sem agendado/perdido)
export const FASES_HISTORICO = ETAPAS.filter((e) => !["agendado", "perdido"].includes(e.id));

// Mapa de proxima etapa para fluxo de "mensagem enviada → avançar"
export const NEXT_STAGE = { entrada: "m1", m1: "m2", m2: "m3", m3: "m4", m4: "m4" };

export const MOTIVOS_PERDIDO = [
  "Preço",
  "Horário",
  "Não respondeu",
  "Foi para outro salão",
  "Sem interesse agora",
  "Outro",
];

// Etiqueta amigável para o tipo do pipeline (interno continua "novo"/"base")
export const TIPO_LABEL = { novo: "Cliente nova", base: "Cliente da base" };
